export default __webpack_public_path__ + "static/media/logo.ac0d3c44.svg";